export const getFirstValidationErrorMessage = (
  validations = { required: { value: true, message: 'enter email' } }
) => {
  const keys = Object.keys(validations)
  return validations[keys[0]].message
}
